var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditBlackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68867 16.8867H1.68867C1.20867 16.8867 0.888672 16.5667 0.888672 16.0867V12.0867C0.888672 11.8467 0.968672 11.6867 1.12867 11.5267L11.5287 1.12672C11.8487 0.806719 12.3287 0.806719 12.6487 1.12672L16.6487 5.12672C16.9687 5.44672 16.9687 5.92672 16.6487 6.24672L6.24867 16.6467C6.08867 16.8067 5.92867 16.8867 5.68867 16.8867ZM2.4885 15.2869H5.3685L14.9685 5.68686L12.0885 2.80686L2.4885 12.4069V15.2869Z",
    fill: "#58595B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlackIcon);
export default __webpack_public_path__ + "static/media/editBlackIcon.2311b91db0106768560e9f6e8f92cb34.svg";
export { ForwardRef as ReactComponent };